import { IPitch, IScore } from "../../../../../../common/types";
import intervalOfNotes from "../../../../../../common/helpers/intervalOfNotes";
import getInterval from "../../../../../../common/helpers/getInterval";

const intervalOptions = [
    [],
    ["B1", "T1"],
    ["s2", "k2", "N2", "B2"],
    ["s3", "k3", "N3", "B3"],
    ["s4", "T4", "B4"],
    ["B5", "T5", "s5"],
    ["s6", "k6", "N6", "B6"],
    ["s7", "k7", "N7", "B7"],
    ["s8", "T8", "B8"],
    ["s9", "k9", "N9", "B9"],
    ["s10", "k10", "N10", "B10"],
];
const downExtended = [
    "s2",
    "s3",
    "s4",
    "s6",
    "s7",
    "s8",
    "s9",
    "s10"
];
const upExtended = [
    "B1",
    "B2",
    "B3",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "B10",
];

export const getIntervalKnowledge = (score: IScore) => {
    const intervals = new Set();
    for (let bar of score.bars) {
        if (!bar || bar.notes.length === 0) continue;
        const note = bar.notes[0];
        const p = note.p as IPitch[];
        const step = intervalOfNotes(p[0], p[1]);
        const solution = getInterval(step.i, step.r);
        intervals.add(solution);
    }
    return intervalOptions.map(options => {
        let hasOption: boolean | { down: boolean, up: boolean } = false;
        options.forEach(option => {
            if (intervals.has(option)) {
                hasOption = true;
            }
        });
        if (hasOption) {
            const levelIntervals = options.filter(option => intervals.has(option));
            hasOption = {
                down: downExtended.filter(d => levelIntervals.includes(d)).length > 0,
                up: upExtended.filter(u => levelIntervals.includes(u)).length > 0,
            }
        }
        return hasOption as false | { down: boolean, up: boolean };
    });
};